import React, { useState } from 'react';
import HouseSmartPartnersStyles from './HouseSmartPartners.styled';
import HouseSmartPartnerContent from './HouseSmartPartnersContent';
import { getFOBShortName } from '../../../utils/utils';

export const HouseSmartPartners = ({ dealer }) => {
  return (
    <HouseSmartPartnersStyles id="OurPartners">
      <div className="container">
        <h2>Our Partners</h2>
        <HouseSmartPartnerContent />
        <div className="disclaimer">
          <p>
            Trademarks of companies other than{' '}
            {getFOBShortName(dealer?.brandAcronym)} Homes are the property of
            those other companies.
          </p>
          <p>
            Material brands are subject to change depending on availability,
            home model and building facility constructing the home.
          </p>
        </div>
      </div>
    </HouseSmartPartnersStyles>
  );
};

export default HouseSmartPartners;
